export function convertCheckboxGroupItemsToCheckboxGroup(checkboxGroupItems, groupLabel, groupValue) {
  return {
    items: checkboxGroupItems,
    label: groupLabel,
    value: groupValue
  };
}